import { env } from "env";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";

export const CGUPage: React.FC = () => {
  const { network} = useSalesNetwork();
  const fileName = network?._parameters.termsAndConditions;
  const fileSrc = `${env.api_url}/assets/data/cgu/${(fileName && fileName !== '' ? fileName : 'cgu_en')}.pdf#toolbar=1&navpanes=0`;
  return (
    <group data-direction="column" data-height="autofit"
      style={{minHeight: 700}}
      >
      <iframe
        src={fileSrc}
        type="application/pdf"
        width="100%"
        height="100%"
      ></iframe>
    </group>
  );
};
